<template>
  <div class="MyCenter">
    <b-row class="profile-usertitle-bg">
      <b-col
        v-if="showVisable == 0 || showVisable == 400"
        cols="4"
        class="mt-5 ml-3"
      >
        <div class="profile-userpic">
          <img :src="userImage" class="img-responsive" />
        </div>
      </b-col>
      <b-col cols="7" v-if="showVisable == 0 || showVisable == 400">
        <div class="profile-usertitle col-sm-6 mt-5">
          <h6 class="card-title profile-usertitle-name">
            {{ userInfor.fullName }}
          </h6>
          <div class="profile-usertitle-job" v-show="showVisable == 0">
            组织机构：{{ userInfor.orgName }}
          </div>
          <div class="profile-usertitle-job" v-show="showVisable == 400">
            组织机构：{{ userInfor.businessOrg }}
          </div>
          <div class="profile-usertitle-job" v-show="showVisable == 0">
            职务：{{ userInfor.position }}
          </div>
          <div class="profile-usertitle-job" v-show="showVisable == 400">
            职务：{{ userInfor.partDescription }}
          </div>
          <div class="profile-usertitle-job">
            工号：{{ userInfor.jobNumber || "无" }}
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="text-center mt-3 mb-3">
        <!--  <b-btn-group>
                  <button type="button" class="btn btn-danger" @click="loginOut">
                    退出登录
                  </button>
                </b-btn-group> -->
      </b-col>
    </b-row>
    <div class="cellView">
      <van-cell @click="$router.push({ name: 'changePhone1' })">
        <template #title>
          <img
            style="width: 22px; margin-right: 13px"
            src="@/assets/imgs/电话号码.png"
            alt=""
          />
          <span class="custom-title">电话号码: {{ phoneNumber }}</span>
        </template>
        <template #right-icon>
          <van-tag plain type="primary">更换</van-tag>
        </template>
      </van-cell>
      <van-cell @click="$router.push({ name: 'changeMail' })">
        <template #title>
          <img
            style="width: 22px; margin-right: 13px"
            src="@/assets/imgs/电子邮箱.png"
            alt=""
          />
          <span class="custom-title">电子邮箱: {{ userInfor.email }}</span>
        </template>
        <template #right-icon>
          <van-tag plain type="primary">更换</van-tag>
        </template>
      </van-cell>
      <div v-if="showVisable == 100">
        <van-cell title="企业名称" :value="user.companyName"></van-cell>
        <van-cell title="统一社会信用代码" :value="user.creditCode"></van-cell>
        <van-cell title="联系人" :value="user.contactName"></van-cell>
        <van-cell title="联系电话" :value="user.contactTel"></van-cell>
      </div>
      <van-cell
        class="mt-2 text-center"
        @click="$router.push({ name: 'changePassword' })"
      >
        <template #title>
          <van-icon name="lock" style="vertical-align: text-bottom" size="20" />
          <span class="custom-title">修改登录密码</span>
        </template>
      </van-cell>
      <van-cell
        v-if="showBindWeixin"
        class="mt-2 text-center"
        style="background: #1989fa; color: white"
        @click="bindWX"
      >
        <template #title>
          <span class="custom-title">绑定微信</span>
        </template>
      </van-cell>
      <van-cell
        class="mt-2 text-center"
        style="background: #ff976a; color: white"
        @click="loginOut"
      >
        <template #title>
          <span class="custom-title">退出登录</span>
        </template>
      </van-cell>
      <van-cell
        v-if="showUnBindWeixin"
        class="mt-2 text-center"
        style="background: #1989fa; color: white"
        @click="unbindWX"
      >
        <template #title>
          <span class="custom-title">解除微信绑定</span>
        </template>
      </van-cell>
    </div>
  </div>
</template>
<script>
var userInfor = JSON.parse(localStorage.getItem("userInfo"));
export default {
  name: "MyCenter",
  computed: {
    showVisable() {
      return userInfor.currentUser.userType;
    },
    phoneNumber() {
      return userInfor.currentUser.tel;
    },
    userInfor() {
      return userInfor.currentUser;
    },
    userImage() {
      if (
        userInfor.currentUser &&
        userInfor.currentUser.headImage &&
        userInfor.currentUser.headImage.length > 0
      ) {
        return process.env.VUE_APP_BASE_API + userInfor.currentUser.headImage;
      } else {
        return require("@/assets/imgs/default.png");
      }
    },
  },
  data() {
    return {
      user: {},
      showBindWeixin: false,
      showUnBindWeixin: false,
    };
  },
  methods: {
    bindWX() {
      this.$dialog
        .confirm({
          title: "授权提示",
          message: "获取您的昵称、头像、地区及性别",
          confirmButtonText: "允许",
          confirmButtonColor: "rgb(25, 137, 250)",
          cancelButtonText: "取消",
        })
        .then(() => {
          this.$router.replace("/author");
        })
        .catch(() => {
          // on cancel
        });
    },
    unbindWX() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "你确认要解除微信绑定吗？",
        })
        .then(() => {
          this.request({
            url: "/v1.0/user/unBindWeixin",
            method: "POST",
          }).then((res) => {
            if (res.success) {
              this.$toast.success("解绑成功");

              let userInfor = JSON.parse(localStorage.getItem("userInfo"));
              userInfor.currentUser.openId = null;
              localStorage.setItem("userInfo", JSON.stringify(userInfor));
              // this.initData();
              this.$router.go(0);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    loginOut() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "你确认退出登录？",
        })
        .then(() => {
          // on confirm
          localStorage.clear();
          localStorage.removeItem("userInfo");
          localStorage.setItem("changelogin","changelogin")
          location.reload();
        })
        .catch(() => {
          // on cancel
        });
    },
    initData() {
      let openid = userInfor.currentUser.openId;
      if (openid == null || openid == "") {
        this.showBindWeixin = true;
      } else {
        this.showUnBindWeixin = true;
      }
      this.$store.dispatch("user").then(() => {
        const { companyName, creditCode, contactName, contactTel, email } =
          this.$store.getters["user"];
        this.user = {
          companyName,
          creditCode,
          contactName,
          contactTel,
          email,
        };
      });
    },
  },
  created() {
    this.initData();
  },
};
</script>

<style type="text/css" scoped>
.MyCenter {
  position: fixed;
  top: 0;
  bottom: 50px;
  width: 100%;
  overflow: hidden;
  z-index: 1;
  background-color: rgb(247, 248, 250) !important;
}

.cellView {
  margin: 10px auto;
  width: 95%;
}

.profile-userpic {
  text-align: center;
}

.profile-userpic img {
  float: none;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  -webkit-border-radius: 50% !important;
  -moz-border-radius: 50% !important;
  border-radius: 50% !important;
}

.profile-usertitle-bg {
  background: url("../../assets/imgs/02f5521270e421a141675e168a78fd0.png")
    no-repeat;
  background-size: cover;
}

.profile-usertitle-name {
  font-size: 25px;
  color: #fff;
}

.profile-usertitle-job {
  font-size: 15px;
  color: #fff;
}
</style>
